import {Component, OnInit} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import {SessionService} from './services/session.service';
import {DialogService} from './services/dialog.service';
import {LoaderService} from './services/loader.service';
import {Subscription} from 'rxjs';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {SEOService} from './services/seo.service';
import {filter, map, mergeMap} from 'rxjs/operators';
import { EncryptServiceService } from './services/encrypt-service/encrypt-service.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    title = 'FAD Masivo';
    masInfo = false;
    mostrarCookies = true;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;
    cookies: any;
    subscriptions: Subscription[] = [];
    public loading: boolean;
    public timer: any;

    constructor(
        private deviceService: DeviceDetectorService,
        private sessionService: SessionService,
        private dialogService: DialogService,
        private loaderService: LoaderService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private encrypt: EncryptServiceService,
        // tslint:disable-next-line:variable-name
        private _seoService: SEOService
    ) {

        this.subscriptions.push(
            this.loaderService.awaitLoader().subscribe(
                action => {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                        this.loading = action;
                    }, 5);
                }
            )
        );

        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        this.cookies = this.sessionService.getCookies();

        setTimeout(() => {
            if (this.cookies === null) {
                dialogService.showPromo();
            }
        }, 3000);

    }

    aceptarCookies(): void {
        this.mostrarCookies = false;
        this.sessionService.setCookies('twgx5wxc7qorev0wys1re2olkl9mdo2i');
    }

    ngOnInit(): void {
    //    console.log(this.encrypt.decryptData('VTJGc2RHVmtYMStHMTBTbkxoY2w5SWVTdmNtVWpkVEdPWldEM2NBUGtGNHFBYm0rclgzRmRQUWhGMDhBN0w3WTBmQk9zVzBROHZpZUNHZnlhaDdzNkE9PQ=='));
    //     console.log(this.encrypt.decryptData('VTJGc2RHVmtYMTlMcW1WMERaMUhxS0JzMEZ1UEF6eFVyeVB1WlZZS3pzWkMzbzRTWVJCdGFiMWx1WnE1Y1RJS21YT0NRMVgzVkQ0QklpTzlUa0tVR2c9PQ=='));
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map((route) => {
                while (route.firstChild) {
                    route = route.firstChild;
                }
                return route;
            }),
            filter((route) => route.outlet === 'primary'),
            mergeMap((route) => route.data)
        )
            .subscribe((event) => {
                this._seoService.updateDATA(
                    event.TITLE,
                    event.KEYWORDS,
                    event.DESCRIPTION,
                    event.URL,
                    event.IMG
                );
            });
    }
}
